import { submitShopInquiry as submitShopInquiryApi } from './api';
import { openShopInquiryWhatsApp } from './shopWhatsAppInquiry';

function mapCartToInquiryItems(cart) {
  return cart.map((item) => ({
    model: item.id,
    qty: item.quantity,
    advance: item.advanceAmount,
    colorRequest: item.customRequest || '',
  }));
}

export async function submitShopInquiryFromCart({ cart, customerName, phone, locale, orderType }) {
  const result = await submitShopInquiryApi({
    customerName: customerName.trim(),
    phone: phone.trim(),
    receiptLocale: locale,
    orderType,
    items: mapCartToInquiryItems(cart),
  });
  return result.inquiry;
}

export function openShopInquiryWhatsAppFromCart({
  inquiry,
  cart,
  customerName,
  phone,
  deliveryDate,
  itemName,
  orderType,
  t,
}) {
  openShopInquiryWhatsApp({
    inquiryNo: inquiry?.inquiryNo || '',
    cart,
    customerName: customerName.trim(),
    phone: phone.trim(),
    deliveryDate,
    itemName,
    hidePrices: orderType === 'wholesale',
    t,
  });
}
